
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 27","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.994 18.92v5.44c0 1.09 1.05 1.87 2.092 1.557l3.955-1.186 3.955 1.186a1.625 1.625 0 002.092-1.556v-5.446c-.45.252-.959.413-1.5.458v4.988c0 .083-.081.143-.161.12l-3.955-1.187a1.499 1.499 0 00-.862 0L6.655 24.48a.125.125 0 01-.16-.12v-4.986a3.712 3.712 0 01-1.5-.454z","fill":"#E6E7E9"}}),_c('path',{attrs:{"d":"M9.115 3.173a2.973 2.973 0 013.857 0c.716.61 1.607.98 2.545 1.055a2.973 2.973 0 012.727 2.726A4.472 4.472 0 0019.3 9.5a2.972 2.972 0 010 3.856 4.472 4.472 0 00-1.055 2.545 2.973 2.973 0 01-2.727 2.727 4.473 4.473 0 00-2.545 1.054 2.973 2.973 0 01-3.857 0 4.474 4.474 0 00-2.546-1.054A2.973 2.973 0 013.842 15.9a4.472 4.472 0 00-1.054-2.545 2.972 2.972 0 010-3.856c.61-.717.98-1.607 1.054-2.546A2.973 2.973 0 016.57 4.228a4.474 4.474 0 002.546-1.055z","stroke":"#E6E7E9","stroke-width":"1.5"}}),_c('circle',{attrs:{"cx":"11.042","cy":"11.429","fill":"#E6E7E9","r":"3.628"}})])
          )
        }
      }
    